import { useNavigate } from 'react-router-dom';

interface ClassCardProps {
  id: string;
  name: string;
  course: string;
  teachers: string[];
  file?: string | null;
  teacherProfiles?: {
    name: string;
    image: string | null;
  }[];
}

const ClassCard = ({
  id,
  name,
  course,
  teachers,
  file,
  teacherProfiles
}: ClassCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex gap-4 p-4 bg-white rounded-2xl shadow hover:shadow-md transition-all cursor-pointer"
      onClick={() => navigate(`/class/${id}`)}
    >
      <div className="w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden bg-gray-200 flex items-center justify-center">
        {file ? (
          <img src={file} alt={name} className="w-full h-full object-cover" />
        ) : (
          <span className="text-gray-400 text-xs">No Image</span>
        )}
      </div>

      <div className="flex flex-col justify-center gap-2">
        <h3 className="font-bold text-gray-900 text-base truncate">
          {course}
        </h3>
        <div className="flex items-center gap-2">
          {teacherProfiles?.[0]?.image ? (
            <img
              src={teacherProfiles[0].image}
              alt={teacherProfiles[0].name}
              className="w-8 h-8 rounded-full object-cover border-2 border-blue-100"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center border-2 border-gray-100">
              <i className="ri-user-line text-sm text-gray-400"></i>
            </div>
          )}
          <span className="text-sm text-gray-500">{teachers.join(', ')}</span>
        </div>
      </div>
    </div>
  );
};

export default ClassCard;
